import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiHeart, FiClock, FiCalendar, FiSmile, FiDatabase, FiTarget, FiHeadphones, FiTrendingUp, FiMessageSquare, FiGift } = FiIcons;

const TipsSection = () => {
  const tips = [
    {
      icon: FiHeart,
      title: "Evita la frustración de tus clientes",
      description: "Con Ticket Factura, el comensal puede facturar en segundos sin esperar 12 o 24 horas. Una buena comida no debería arruinarse con un mal proceso de facturación."
    },
    {
      icon: FiClock,
      title: "Ahorra tiempo de tu personal",
      description: "Ya no tendrán que detenerse a ayudar a clientes que no encuentran el ticket o no entienden el portal. Así, tu equipo se concentra en lo importante: dar un gran servicio."
    },
    {
      icon: FiCalendar,
      title: "Facturación disponible todo el mes",
      description: "A diferencia de otros sistemas, Ticket Factura permite que el cliente facture durante todo el mes del consumo, reduciendo quejas y pérdidas de clientes."
    },
    {
      icon: FiSmile,
      title: "Simplicidad que enamora",
      description: "El comensal solo necesita unos pocos datos para facturar. Menos pasos = mayor satisfacción y fidelidad de tus clientes."
    },
    {
      icon: FiDatabase,
      title: "Datos fiscales siempre listos",
      description: "Una vez que el cliente factura por primera vez, sus datos se guardan automáticamente para futuros consumos. La segunda factura es todavía más rápida."
    },
    {
      icon: FiTarget,
      title: "QR inteligente en cada ticket",
      description: "El código QR lleva directamente a la página de facturación y rellena automáticamente los datos del ticket y del cliente. Cero errores, cero pérdida de tiempo."
    },
    {
      icon: FiHeadphones,
      title: "Servicio al cliente integrado",
      description: "Si surge algún problema, Ticket Factura atiende directamente al consumidor. Así, tu restaurante no pierde tiempo en soporte ni queda mal con el cliente."
    },
    {
      icon: FiTrendingUp,
      title: "Convierte la facturación en experiencia positiva",
      description: "Tus clientes recordarán lo fácil que fue facturar contigo y lo recomendarán. Eso genera recompras y lealtad hacia tu restaurante."
    },
    {
      icon: FiMessageSquare,
      title: "Conoce mejor a tus clientes",
      description: "Ticket Factura incluye encuestas de satisfacción al final de cada facturación. Obtienes retroalimentación valiosa para mejorar la experiencia de tu restaurante."
    },
    {
      icon: FiGift,
      title: "Empieza sin riesgos",
      description: "Puedes probar Ticket Factura por un mes totalmente gratis. Así experimentas todos los beneficios sin compromiso y descubres cómo aumenta la satisfacción de tus clientes."
    }
  ];

  return (
    <section 
      className="py-20 relative"
      style={{
        backgroundImage: 'url(https://www.ticketfactura.com/wp-content/uploads/2025/09/restaruant-sales.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay for better contrast */}
      <div className="absolute inset-0 bg-black bg-opacity-75"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            🔟 TIPS de valor para tu restaurante con <span className="text-yellow-400">Ticket Factura</span>
          </h2>
          
          <div className="max-w-4xl mx-auto mb-12 p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg border border-yellow-400">
            <p className="text-lg text-white">
              <span className="text-yellow-400 font-semibold">Ticket Factura no es solo facturación,</span>{' '}
              <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent font-bold text-xl">
                es una herramienta para vender más, fidelizar a tus clientes y ahorrar costos en tu restaurante.
              </span>
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {tips.map((tip, index) => (
            <motion.div
              key={index}
              className="bg-white bg-opacity-15 backdrop-blur-md rounded-lg p-6 border border-white border-opacity-20 hover:bg-opacity-25 transition-all duration-300"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02, y: -5 }}
            >
              <SafeIcon icon={tip.icon} className="text-3xl text-yellow-400 mb-4" />
              <h3 className="text-lg font-bold mb-3 text-white">{tip.title}</h3>
              <p className="text-gray-200 text-sm leading-relaxed">{tip.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 rounded-lg p-6 max-w-2xl mx-auto">
            <p className="text-lg font-bold">
              👉 Con estos 10 TIPS, el mensaje clave es: Ticket Factura transforma la experiencia de facturación en una ventaja competitiva para tu restaurante.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TipsSection;